import { EventType } from '@/features/events/shared'
import type { BlockingBucket } from './types'

export const BLOCKING_INBOX_Z_INDEX = 1350
export const BLOCKING_INBOX_PANEL_Z_INDEX = 1351
export const BLOCKING_INBOX_BACKDROP_Z_INDEX = BLOCKING_INBOX_Z_INDEX - 1

export const PLAN_INTENT = 'Plan is ready'
export const QUESTIONNAIRE_INTENT = "Answer agent's questions"
export const ERRORED_FALLBACK_INTENT = 'Request needs your attention'
export const ERRORED_CONTEXT_SUFFIX = ' — needs review'
export const ERRORED_NEEDS_REVIEW = 'Needs review'

export const BLOCKING_BUCKET_ORDER: readonly BlockingBucket[] = [
  EventType.TOOL_PERMISSION_REQUEST,
  EventType.PLAN_APPROVAL_REQUEST,
  EventType.AGENT_QUESTIONS,
  EventType.ERRORED_EVENT,
]

/**
 * Pluralized panel headers. The panel always lists multiple sessions under one
 * bucket, so the header reads as a category rather than the singular
 * resolveEventTypeLabelFor() label used elsewhere.
 */
export const BUCKET_HEADER_LABELS: Readonly<Record<BlockingBucket, string>> = {
  [EventType.TOOL_PERMISSION_REQUEST]: 'Tool Permission Requests',
  [EventType.AGENT_QUESTIONS]: 'Agent Questions',
  [EventType.PLAN_APPROVAL_REQUEST]: 'Plan Approval Requests',
  [EventType.ERRORED_EVENT]: 'Errored Requests',
}
